export default __webpack_public_path__ + "static/media/02_sprej-ke-znaceni-stromu.2e66fbfd.jpg";